import React from 'react'
import ThemeSelection from '../Components/ThemeSelection'

const Home = () => {
  return (
    <div className="App">
    <ThemeSelection />
  </div>
  )
}

export default Home